import { useEffect } from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch-hooks-web';
import { useDispatch } from '@client/hooks/redux.hooks';
import { setExtraHits, setHits, setMapStatus } from '@client/slices/features/map.reducer';
import type { GeolocHit } from '@sda/helpers/algolia.helpers';

interface HitsProps {
  readonly isExtraHits?: boolean;
}

export const Hits: React.FC<HitsProps> = ({ isExtraHits }) => {
  const { status } = useInstantSearch();
  const result = useHits<GeolocHit<any>>();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isExtraHits) {
      dispatch(setExtraHits(result.hits));
    } else {
      dispatch(setHits(result.hits));
      dispatch(setMapStatus(true));
    }
  }, [dispatch, result, status, isExtraHits]);

  return null;
};
